import React, { memo, Fragment, useEffect } from 'react';
import { FormInput } from '@core/components/form';
import { useObservable, useNonNilObservable } from '@core/utils/hooks/rxjs';
import { Col, Row, Label } from 'reactstrap';
import { FlashCardForm } from '.';
import { FormRadio, FormRadioGroup } from '@core/components/form/FormRadio';

export interface ScenarioDrillItemProps {
  control: FlashCardForm;
}

export const ScenarioDrillItem = memo((props: ScenarioDrillItemProps) => {
  const { control } = props;
  const answers = useObservable(control.controls.answers.items$, []);

  useEffect(() => {
    if (answers.length === 0) {
      control.controls.answers.push();
    }
  }, [control.controls.answers, answers]);

  return (
    <Fragment>
      <Label>Answers</Label>
      {answers.map((ctrl, index) => {
        return (
          <React.Fragment key={`section-${index}`}>
            <Row>
              <Col md={8}>
                <FormInput control={ctrl.controls.option} />
              </Col>
              <Col md={2} className="mt-2">
                <FormRadioGroup control={control.controls.correntAnswerIndex}>
                  <FormRadio label={'Correct Answer'} value={index} />
                </FormRadioGroup>
              </Col>
              <Col md={2}>
                {!index && (
                  <a className="btn btn-outline-primary btn-sm" onClick={() => control.controls.answers.push()}>
                    Add Answer
                  </a>
                )}
                {!!index && (
                  <a className="btn btn-outline-danger btn-sm" onClick={() => control.controls.answers.removeAt(index)}>
                    <i className="bx bx-x"></i>
                  </a>
                )}
              </Col>
            </Row>
          </React.Fragment>
        );
      })}
    </Fragment>
  );
});
